import createEmbedConfig from '../config';
import InstanceRegistry from './InstanceRegistry';
import InstanceController from './InstanceController';
import authorizationTokenProviderFactory from './authorization/authorizationTokenProvider';
import getWrapperElement from './interface/getWrapperElement';

const SCRIPT_LOAD_TIMEOUT = 3500;
const authorizationTokenProvider = authorizationTokenProviderFactory(SCRIPT_LOAD_TIMEOUT);

const instanceRegistry = new InstanceRegistry();
const instanceController = new InstanceController(
	instanceRegistry,
	authorizationTokenProvider
);

const CONFIG = {
	isStagingBuild: typeof $isStagingBuild !== 'undefined' ? $isStagingBuild : ''
};

export function create(service, element, configuration = {}) {
	element = getWrapperElement(element);

	if (!element) {
		throw new Error(
			'SznDiscussion: Cannot create iframe for embedded discussion. ' +
				'Provided element does not exist or selector does not match any existing element.'
		);
	}

	const instance = instanceRegistry.initializeDiscussionInstance(
		service,
		element,
		createEmbedConfig(configuration, CONFIG.isStagingBuild),
		authorizationTokenProvider
	);

	instanceController.onNewDiscussionCreated(instance);

	return {
		loadDiscussion: instance.loadDiscussion.bind(instance),
		loadThread: instance.loadThread.bind(instance),
		loadReplies: instance.loadReplies.bind(instance),
		loadConversation: instance.loadConversation.bind(instance),
		listen: instance.listen.bind(instance),
		unlisten: instance.unlisten.bind(instance),
		unload: function unload() {
			instanceRegistry.destroyDiscussionInstance(instance);
			instance.unload();
		}
	};
}
